window.options = {
	errorClass: 'has-error',
	validClass: 'has-success',
	errorPlacement: function(error, element){
		if(element.hasClass('select2') && element.next('.select2-container').length){
			error.insertAfter(element.next('.select2-container'));
		}else if(element.parent('.input-group').length){
			error.insertAfter(element.parent());
		}if(element.hasClass('tags-input') && element.next('.tagsinput').length){
			error.insertAfter(element.next('.tagsinput'));
		}else if(element.prop('type') === 'radio' && element.parent('.radio-inline').length){
			error.insertAfter(element.parent().parent());
		}else if(element.prop('type') === 'checkbox' || element.prop('type') === 'radio'){
			error.appendTo(element.parent().parent());
		}else{
			error.insertAfter(element);
		}
	},
    highlight: function(element, errorClass, validClass){
        if ($(element).prop('required')) {
            $(element).closest('.form-group, tr').removeClass(validClass).addClass(errorClass);
        }
    },
    unhighlight: function(element, errorClass, validClass){
        if ($(element).prop('required')) {
            $(element).closest('.form-group, tr').removeClass(errorClass).addClass(validClass);
        }
        if ($(element).attr('type') === 'checkbox' && $(element).closest('label').length){
            $(element).closest('label').next(errorClass).remove();
        } else if ($(element).attr('type') === 'radio' && $('[name="'+ $(element).attr('name') +'"]:eq(-1)').closest('label').length){
            $('[name="'+ $(element).attr('name') +'"]:eq(-1)').closest('label').next(errorClass).remove();
        } else {
            $(element).next(errorClass).remove();
        }
    }
};
$(function(){
	$('form').each(function(){
		$(this).validate(options);
	});
});
